export const store = {
    searchOpen: false,
    windowWidth: window.innerWidth,
    mobileMenuOpen: false,
}
